import React, { useState } from 'react';
import { useRouter } from 'next/navigation';
import styles from './EBBBottomNav.module.css';
import { useAppContext } from "@components/Provider";
import Image from 'next/image';

const EBBBottomNav = ({ activeBottomNavIndex }) => {
    const { data, showBottomNav = true } = useAppContext();
    const router = useRouter();
    const [activeIndex, setActiveIndex] = useState(null);
    const navItems = data?.SiteSettings?.site_header?.nav_items?.filter(item => item?.text !== "My Account") || [];

    const handleMenuClick = (index, item) => {
        // Check if the item has submenus
        const hasSubmenus = item?.subMenus && item?.subMenus.length > 0;
        
        if (hasSubmenus) {
            // If item has submenus, open the menu with this item expanded
            const mainNavItems = data?.SiteSettings?.site_header?.nav_items || [];
            const mainNavIndex = mainNavItems.findIndex(
                navItem => navItem?.text === item?.text
            );

            if (mainNavIndex !== -1) {
                setActiveIndex(activeIndex === mainNavIndex ? null : mainNavIndex);
                activeBottomNavIndex(mainNavIndex);
            }
        } else {
            // If item is a direct link, navigate to the URL
            if (item?.url) {
                if (item?.external) {
                    // Open external links in new tab
                    window.open(item.url, '_blank', 'noopener');
                } else {
                    // Navigate to internal links
                    router.push(item.url);
                }
            }
        }
    };

    if (!showBottomNav) {
        return null;
    }

    return (
        <nav className={styles.bottomNav}>
            {navItems.map((item, idx) => {
                const mainNavItems = data?.SiteSettings?.site_header?.nav_items || [];
                const mainNavIndex = mainNavItems.findIndex(
                    navItem => navItem?.text === item?.text
                );
                const isActive = activeIndex === mainNavIndex;
                const hasSubmenus = item?.subMenus && item?.subMenus.length > 0;

                return (
                    <a
                        key={idx}
                        href="#"
                        className={`${styles.navItem} ${isActive ? styles.active : ''}`}
                        onClick={(e) => {
                            e.preventDefault();
                            handleMenuClick(idx, item);
                        }}
                    >
                        {item?.imageUrl && (
                            <Image
                                src={item.imageUrl}
                                alt={item?.text || ''}
                                width={40}
                                height={40}
                                className={styles.icon}
                            />
                        )}
                        <span className={styles.label}>{item?.text || ''}</span>
                    </a>
                );
            })}
        </nav>
    );
};

export default EBBBottomNav; 